import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { framerEasings, onIntentToDismissUp } from "../../../utils/framerUtils";
import { AppButton } from "../../Generic/AppButton";

export default function DismissableMainLayoutBanner(props: {
  text: string;
  actionText: string;
  isOpen: boolean;
  onClickAction: () => void;
  onClose: () => void;
}) {
  return (
    <AnimatePresence>
      {props.isOpen && (
        <Root
          initial={{ translateY: "-100%", scale: 0.7 }}
          animate={{ translateY: 0, scale: 1 }}
          exit={{ translateY: "-100%", opacity: 0, scale: 0.7 }}
          drag="y"
          transition={{ duration: 0.4, ease: framerEasings.custom }}
          dragConstraints={{ top: 0, bottom: 0 }}
          dragElastic={{ bottom: 0.1, top: 0.4 }}
          onPanEnd={onIntentToDismissUp(props.onClose)}
        >
          <Text>{props.text}</Text>
          <AppButton variant="link" onClick={props.onClickAction}>
            {props.actionText}
          </AppButton>
        </Root>
      )}
    </AnimatePresence>
  );
}

const Root = styled(motion.div)`
  margin: 8px 16px;
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;

  background: #fff;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Text = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--tw-slate-900);
  flex: 1;
`;
